<template>
  <div class="summary-tile">
    <div class="summary-icon-badge">
      <v-icon color="white" size="20">{{ icon }}</v-icon>
    </div>

    <div class="summary-body">
      <v-skeleton-loader
        v-if="loading"
        type="text"
        height="20px"
        width="50px"
        class="!tw-m-0"
      >
      </v-skeleton-loader>
      <p v-else class="summary-count">{{ count }}</p>
      <p class="summary-title">{{ title }}</p>
      <router-link
        :to="`/dashboard/report/?category=${category}`"
        class="summary-link"
      >
        See all
        <v-icon size="14" color="primary">mdi-chevron-right</v-icon>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    count: Number,
    title: String,
    loading: Boolean,
    category: String,
    icon: {
      type: String,
      default: 'mdi-chart-box-outline',
    },
  },
}
</script>

<style scoped>
.summary-tile {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px;
  background: #ffffff;
  border: 1px solid #e8edf5;
  border-radius: 14px;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}
.summary-tile:hover {
  box-shadow: 0 10px 24px rgba(3, 78, 162, 0.1);
  transform: translateY(-2px);
}
.summary-icon-badge {
  flex: 0 0 auto;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: #034ea2;
  display: flex;
  align-items: center;
  justify-content: center;
}
.summary-body {
  min-width: 0;
}
.summary-count {
  font-size: 22px;
  font-weight: 700;
  line-height: 1.1;
  color: #0f2a55;
  margin: 0;
}
.summary-title {
  font-size: 12.5px;
  color: #6b7684;
  line-height: 1.3;
  margin: 4px 0 6px;
}
.summary-link {
  display: inline-flex;
  align-items: center;
  font-size: 13px;
  font-weight: 600;
  color: #034ea2;
  text-decoration: none;
}
.summary-link:hover {
  text-decoration: underline;
}
</style>
